import { render, staticRenderFns } from "./TituloRelatorioTotalizadores.vue?vue&type=template&id=73b5d10c&"
import script from "./TituloRelatorioTotalizadores.vue?vue&type=script&lang=js&"
export * from "./TituloRelatorioTotalizadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports